import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const WA_SVG = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

const BRANCHEN_GRUPPEN = [
  {
    label: 'Gastronomie',
    items: [
      { key: 'gastro', name: 'Restaurant & Café', icon: '🍽️' },
      { key: 'hotel', name: 'Hotel & Pension', icon: '🏨' },
      { key: 'catering', name: 'Catering', icon: '🥗' },
    ],
  },
  {
    label: 'Gesundheit',
    items: [
      { key: 'arzt', name: 'Arztpraxis', icon: '🏥' },
      { key: 'zahnarzt', name: 'Zahnarztpraxis', icon: '🦷' },
      { key: 'physiotherapie', name: 'Physiotherapie', icon: '🏃' },
      { key: 'apotheke', name: 'Apotheke', icon: '💊' },
    ],
  },
  {
    label: 'Beauty & Wellness',
    items: [
      { key: 'fitness', name: 'Fitnessstudio', icon: '💪' },
      { key: 'friseur', name: 'Friseursalon', icon: '✂️' },
      { key: 'kosmetik', name: 'Kosmetikstudio', icon: '💅' },
      { key: 'nagelstudio', name: 'Nagelstudio', icon: '🌸' },
    ],
  },
  {
    label: 'Handwerk & Technik',
    items: [
      { key: 'handwerk', name: 'Handwerksbetriebe', icon: '🔧' },
      { key: 'autowerkstatt', name: 'Autowerkstatt', icon: '🚗' },
      { key: 'reinigung', name: 'Reinigungsfirma', icon: '🧹' },
      { key: 'it', name: 'IT & Software', icon: '💻' },
    ],
  },
  {
    label: 'Business & Recht',
    items: [
      { key: 'anwalt', name: 'Anwaltskanzlei', icon: '⚖️' },
      { key: 'steuerberater', name: 'Steuerberater', icon: '📊' },
      { key: 'immobilien', name: 'Immobilienmakler', icon: '🏠' },
      { key: 'recruiting', name: 'Recruiting', icon: '👥' },
    ],
  },
  {
    label: 'Weitere',
    items: [
      { key: 'ecommerce', name: 'Online-Shop', icon: '🛍️' },
      { key: 'fahrschule', name: 'Fahrschule', icon: '🚦' },
      { key: 'reisebuero', name: 'Reisebüro', icon: '✈️' },
      { key: 'event', name: 'Eventplanung', icon: '🎉' },
    ],
  },
];

function Nav() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [branchenOpen, setBranchenOpen] = useState(false);

  const goHome = () => { navigate('/'); window.scrollTo(0, 0); setMenuOpen(false); };
  const scrollTo = (id) => { navigate('/', { state: { scrollTo: id } }); setMenuOpen(false); };
  const go = (path) => { navigate(path); setMenuOpen(false); setBranchenOpen(false); };

  return (
    <>
      <nav className="nav">
        <div className="nav-inner">
          <div className="logo" onClick={goHome}>
            <div className="logo-icon" style={{background:'transparent',borderRadius:0,padding:0,overflow:'hidden'}}>
              <img src="/logo-frontup.png" style={{width:36,height:36,objectFit:'cover',borderRadius:9,display:'block'}} alt="FrontUp" />
            </div>
            <span className="logo-name">FrontUp</span>
          </div>

          <ul className="nav-links">
            <li className="nav-link">
              <button className="nl-btn">
                Branchen
                <svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>
              </button>
              <div className="nav-dropdown">
                <div>
                  <div className="dd-title">Gastronomie</div>
                  <ul className="dd-list">
                    <li className="dd-item" onClick={() => navigate('/branche/gastro')}>Restaurant & Café</li>
                    <li className="dd-item" onClick={() => navigate('/branche/hotel')}>Hotel & Pension</li>
                    <li className="dd-item" onClick={() => navigate('/branche/catering')}>Catering</li>
                  </ul>
                </div>
                <div>
                  <div className="dd-title">Gesundheit</div>
                  <ul className="dd-list">
                    <li className="dd-item" onClick={() => navigate('/branche/arzt')}>Arztpraxis</li>
                    <li className="dd-item" onClick={() => navigate('/branche/zahnarzt')}>Zahnarztpraxis</li>
                    <li className="dd-item" onClick={() => navigate('/branche/fitness')}>Fitnessstudio</li>
                  </ul>
                </div>
                <div>
                  <div className="dd-title">Handwerk</div>
                  <ul className="dd-list">
                    <li className="dd-item" onClick={() => navigate('/branche/handwerk')}>Handwerksbetriebe</li>
                    <li className="dd-item" onClick={() => navigate('/branche/autowerkstatt')}>Autowerkstatt</li>
                    <li className="dd-item" onClick={() => navigate('/branche/reinigung')}>Reinigung</li>
                  </ul>
                </div>
                <div>
                  <div className="dd-title">Business</div>
                  <ul className="dd-list">
                    <li className="dd-item" onClick={() => navigate('/branche/anwalt')}>Anwaltskanzlei</li>
                    <li className="dd-item" onClick={() => navigate('/branche/steuerberater')}>Steuerberater</li>
                    <li className="dd-item" onClick={() => navigate('/branche/immobilien')}>Immobilien</li>
                  </ul>
                </div>
              </div>
            </li>
            <li className="nav-link">
              <button className="nl-btn" onClick={() => scrollTo('anwendung')}>Features</button>
            </li>
            <li className="nav-link">
              <button className="nl-btn" onClick={() => navigate('/ueber-uns')}>Über uns</button>
            </li>
            <li className="nav-link">
              <button className="nl-btn" onClick={() => navigate('/preise')}>Preise</button>
            </li>
          </ul>

          <div className="nav-right">
            <a href="https://wa.me/491791548222" target="_blank" rel="noreferrer" className="btn-whatsapp" title="WhatsApp">
              {WA_SVG}
              WhatsApp
            </a>
            <button className="btn-solid" onClick={() => navigate('/demo-buchen')}>Demo buchen</button>
          </div>

          {/* Hamburger Button */}
          <button
            className="nav-hamburger"
            onClick={() => { setMenuOpen(o => !o); setBranchenOpen(false); }}
            aria-label="Menü öffnen"
          >
            <span className="hb-line" style={menuOpen ? {transform:'rotate(45deg) translate(5px,5px)'} : {}} />
            <span className="hb-line" style={menuOpen ? {opacity:0} : {}} />
            <span className="hb-line" style={menuOpen ? {transform:'rotate(-45deg) translate(5px,-5px)'} : {}} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="mobile-menu">
          <div className="mm-links">
            {/* Branchen Akkordeon */}
            <button
              className="mm-link mm-branchen-toggle"
              onClick={() => setBranchenOpen(o => !o)}
            >
              <span>Branchen</span>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#111" strokeWidth="2"
                style={{transform: branchenOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition:'transform .2s'}}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>

            {branchenOpen && (
              <div className="mm-branchen-list">
                {BRANCHEN_GRUPPEN.map(gruppe => (
                  <div key={gruppe.label} className="mm-gruppe">
                    <div className="mm-gruppe-label">{gruppe.label}</div>
                    {gruppe.items.map(item => (
                      <button key={item.key} className="mm-branche-item" onClick={() => go(`/branche/${item.key}`)}>
                        {item.name}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            )}

            <button className="mm-link" onClick={() => scrollTo('anwendung')}>Features</button>
            <button className="mm-link" onClick={() => go('/ueber-uns')}>Über uns</button>
            <button className="mm-link" onClick={() => go('/preise')}>Preise</button>

            <div className="mm-divider" />
            <a href="https://wa.me/491791548222" target="_blank" rel="noreferrer" className="mm-wa">
              {WA_SVG} WhatsApp schreiben
            </a>
            <button className="mm-cta" onClick={() => go('/demo-buchen')}>Demo buchen</button>
          </div>
        </div>
      )}
    </>
  );
}

export default Nav;
